var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    attrs: {
      options: _vm.options,
      clearable: _vm.clearable,
      disabled: _vm.disabled,
    },
    on: {
      change: _vm.addressChange,
      "active-item-change": _vm.handleItemChange,
    },
    model: {
      value: _vm.regionArray,
      callback: function ($$v) {
        _vm.regionArray = $$v
      },
      expression: "regionArray",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }